module.exports = __webpack_public_path__ + "img/vr-pay.98338dc8.png";